'use client'

import Link from 'next/link'
import { useTranslation } from 'react-i18next'

import { buildLocalePath } from '@/utils'

/**
 * Shared 404 UI. Rendered by `not-found.tsx` (genuine 404s from the catch-all)
 * and by content detail pages for a missing/unpublished slug. On those detail
 * pages the HTTP status stays 200 (a Next streaming limitation — `notFound()`
 * can't set 404 once `generateMetadata` has flushed headers), so those pages
 * pair this with `robots: { index: false }` in `generateMetadata` to keep the
 * non-existent URL out of the search index.
 */
export default function NotFoundContent() {
  const { i18n, t } = useTranslation()

  return (
    <div className='grid h-full min-h-[60vh] place-content-center place-items-center gap-8 py-20'>
      <h2 className='text-6xl font-bold'>404</h2>
      <p className='text-2xl font-bold'>{t('notfound.description')}</p>
      <Link href={buildLocalePath(i18n.language, '/')} className='rounded-md bg-primary p-3 text-2xl font-bold'>
        {t('notfound.link')}
      </Link>
    </div>
  )
}
